import React, {useEffect} from 'react'
import Navbar from '../../layout/Navbar'
import MainGetApp from './MainGetApp'
import Download from './Download'
import BenefitGetApp from './BenefitGetApp'
import AboutApp from './AboutApp'
import Client from '../../layout/Client'
import Review from '../../layout/Review'
import DownloadSection from '../../layout/downloadSection'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'

function GetApp() {
  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, []);
  
  const seo = getSEOData('app');
  return (
    <div className='app'>
      <SEO 
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />      
       <Navbar></Navbar>
       <MainGetApp></MainGetApp>
       <Download></Download>
       <BenefitGetApp></BenefitGetApp>
       <AboutApp></AboutApp>
       <Client></Client>
       <Review></Review>
       <DownloadSection></DownloadSection>
       <Footer></Footer>
    </div>
  )
}

export default GetApp